export const mainRoutes = {
    // If you update mainRoutes make sure to update backButton workflow.
    home: 'home',
    signAgreement: 'signagreement',
    notices: 'notices',
    experience: 'experience',
    businessAndPeople: 'businessAndPeople',
    business: 'business',
    borrower: 'borrower',
    property: 'property',
    budget: 'budget',
    landBudget: 'landBudget',
    fixFlipBudget: 'fixFlipBudget',
    specSheet: 'specsheet',
    review: 'review',
    appraisal: 'appraisal',
    finalize: 'finalize',
    thankYou: 'thankyou',
    controlDemo: 'controldemo',
};
export const reversedRoutes = Object.keys(mainRoutes).reverse();
export const mainRoutesCamelCase = {
    // If you update mainRoutes make sure to update backButton workflow.
    home: 'home',
    signAgreement: 'signAgreement',
    notices: 'notices',
    experience: 'experience',
    businessAndPeople: 'businessAndPeople',
    business: 'business',
    borrower: 'borrower',
    property: 'property',
    budget: 'budget',
    landBudget: 'landBudget',
    fixFlipBudget: 'fixFlipBudget',
    specsheet: 'specSheet',
    review: 'review',
    finalize: 'finalize',
    thankyou: 'thankYou',
    controlDemo: 'controlDemo',
};
